import { computed, ref } from 'vue';
import axios from 'axios';
import { skipHydrate } from 'pinia';
import { usePage } from '@inertiajs/vue3';

export const makeStore = () => {
    const hits = ref([]);
    const query = ref(usePage().props.searchedQuery || '');
    let searching = false;
    const search = async (query, url) => {
        if (!searching) {
            searching = true;
            return axios.get(url, { params: { q: query } }).then(resp => {
                searching = false;
                hits.value = resp.data;
            });
        }
    };

    const modelSearch = computed(() => usePage().props.modelSearch);

    const selectInit = {
        modelTypes: modelSearch.value?.selects?.selected?.modelTypes || null,
        brands: modelSearch.value?.selects?.selected?.brands || null,
        cubatures: modelSearch.value?.selects?.selected?.cubatures || null,
        models: modelSearch.value?.selects?.selected?.models || null,
        years: modelSearch.value?.selects?.selected?.years || null,
    };
    const selected = ref({ ...selectInit });

    const filtering = ref(false);
    const resetSelected = () => {
        selected.value = { ...selectInit };
    };

    const setSelected = (modelTypes, brands, cubatures, models) => {
        selected.value = Object.assign({}, selected.value, {
            modelTypes,
            brands,
            cubatures,
            models,
            years: null
        })
    }

    const logQuery = (query, url) => {
        return axios.post(url, { query });
    };

    return {
        hits: skipHydrate(hits),
        query: skipHydrate(query),
        search,
        selected,
        resetSelected,
        logQuery,
        setSelected,
        filtering
    };


};
